export default "__VITE_ASSET__hGOGuN7g__"